export interface InsuranceCompanyModel {
	denomination: string;
	code: number;
	number_policy: number;
	valid_from: string;
	expires_to: string;
}

export interface CounterpartyCompany {
	entity: Company;
	name?: string;
}

export class Company {
	address: string;
	ania_code: string;
	city: string;
	code: string;
	contact: string;
	contact_pai: string;
	email: string;
	email_pai: string;
	fax: string;
	id?: string;
	is_active?: boolean;
	join_card: boolean;
	name: string;
	province: string;
	state: string;
	telephone: string;
	web_site: string;
	zip_code: string;
}

export const missingCompanyName: string = 'COMPAGNIA NON PRESENTE';
export const foreignCompanyName: string = 'COMPAGNIA ESTERA';
export const missingCompanyId: string = '00000000-0000-0000-0000-000000000001';
export const foreignCompanyId: string = '00000000-0000-0000-0000-000000000000';
